<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>运营区域列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">
        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="toRangeMap(row)">设置范围
          </Button>
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';

export default {
  name: "admin",
  data() {
    return {
      total: 0,
      isTableLoading: false,
      dateInit: '',
      // 参数
      params: {
        page: 1,
        rows: 10,
        changeType: '',
        startTime: '',
        endTime: ''
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          minWidth: 120,
          key: 'regionId'
        },
        {
          title: '运营区域',
          minWidth: 120,
          key: 'localName'
        },
        {
          title: '运营区域全称',
          minWidth: 220,
          key: 'fullName'
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center',
          fixed: 'right'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '系统管理', url: '', icon: '', size: 0},
        {name: '运营范围', url: '', icon: '', size: 0}
      ],
      tenant: {}
    }
  },
  created() {
    // 运营范围-列表查询
    this.findList();
  },
  methods: {
    // 运营范围-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/range/findRangeList').then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.data = res.data;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询资金流水列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 租户详情查询
    toRangeMap(row) {
      console.log('rowww', row);
      this.$router.push({path: '/index/range-map',query:{
          regionId: row.regionId,
          pointsArr: row.mapRange,
        }})
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.username = '';
      this.params.roleId = '';
      this.params.isDisable = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
  components: {
    hsBreadcrumb,
  }
}
</script>

<style scoped>

</style>